"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const kendo_react_inputs_1 = require("@progress/kendo-react-inputs");
const CheckboxComponent = (_a) => {
    var { label } = _a, props = __rest(_a, ["label"]);
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(kendo_react_inputs_1.Checkbox, Object.assign({ role: 'checkbox' }, props)), label && (0, jsx_runtime_1.jsx)("label", { children: label })] }));
};
exports.default = CheckboxComponent;
